import PoetAllInfoWorks from "./PoetAllInfoWorks.jsx"

export default PoetAllInfoWorks
